import * as React from 'react';
const HamburgerIcon = () => (React.createElement("svg", { className: "hamburgerIcon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40" },
    React.createElement("path", { d: "M10 13H30M10 20H30M10 27H30", stroke: "#00183C", strokeWidth: "2" })));
export default HamburgerIcon;
//# sourceMappingURL=HamburgerIcon.js.map